import { Icon } from 'rsuite';

const SCIcon = (props) => {
    return (
        <Icon {...props} />
    )
}

export default SCIcon;